<template>
	<div class="layout-container">
		<!-- 左侧菜单栏 -->
		<div class="sidebar">
			<div class="logo">
				<h2>{{ websiteName || 'AD管理系统' }}</h2>
			</div>
			<el-menu :default-active="$route.path" class="el-menu-vertical" background-color="#fff" text-color="#333"
				active-text-color="#409EFF" router unique-opened v-if="dynamicMenus.length > 0"
				:key="'menu-loaded-' + menuUpdateTime" :default-openeds="currentOpenedMenu ? [currentOpenedMenu] : []"
				@open="handleMenuOpen" @select="handleMenuSelect">
				<template v-for="menu in dynamicMenus">
					<!-- 有子菜单的菜单 -->
					<el-submenu v-if="menu.children && menu.children.length > 0" :key="'submenu-' + menu.id"
						:index="menu.path">
						<template slot="title">
							<i :class="menu.icon || 'el-icon-menu'"></i>
							<span>{{ menu.name }}</span>
						</template>
						<el-menu-item v-for="child in menu.children" :key="'child-' + child.id" :index="child.path">
							<i :class="child.icon || 'el-icon-circle-check'"></i>
							<span>{{ child.name }}</span>
						</el-menu-item>
					</el-submenu>
					<!-- 没有子菜单的菜单 -->
					<el-menu-item v-else :key="'item-' + menu.id" :index="menu.path">
						<i :class="menu.icon || 'el-icon-menu'"></i>
						<span>{{ menu.name }}</span>
					</el-menu-item>
				</template>
			</el-menu>
			<!-- 加载中状态 -->
			<div v-else class="menu-loading" key="menu-loading-state">
				<el-empty :description="emptyDescription"></el-empty>
			</div>
		</div>

		<!-- 右侧内容区域 -->
		<div class="main-container">
			<!-- 顶部导航栏 -->
			<div class="header">
				<div class="header-left">
					<h3>{{ currentRouteTitle }}</h3>
				</div>
				<div class="header-right">
					<el-input v-model="searchText" placeholder="搜索..." prefix-icon="el-icon-search" size="small"
						style="width: 200px; margin-right: 15px"></el-input>
					<el-button icon="el-icon-bell" circle></el-button>
					<el-button icon="el-icon-setting" circle></el-button>
					<el-dropdown>
						<span class="user-info">
							<el-avatar size="small" :src="userInfo.avatar"></el-avatar>
							<span style="margin-left: 8px">{{ userInfo.username }}</span>
						</span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item>个人中心</el-dropdown-item>
							<el-dropdown-item @click.native="handleChangePassword">修改密码</el-dropdown-item>
							<el-dropdown-item divided @click.native="handleLogout">退出登录</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
			</div>

			<!-- Tab标签栏 -->
			<div class="tabs-container">
				<el-tabs v-model="activeTab" type="card" closable @tab-remove="removeTab" @tab-click="clickTab">
					<el-tab-pane v-for="tab in tabs" :key="tab.path" :name="tab.path" :label="tab.title"></el-tab-pane>
				</el-tabs>
			</div>

			<!-- 主要内容区域 -->
			<div class="content">
				<router-view></router-view>
			</div>
		</div>

		<!-- 修改密码对话框 -->
		<el-dialog title="修改密码" :visible.sync="changePasswordDialogVisible" width="500px"
			:before-close="closePasswordDialog">
			<el-form :model="passwordForm" :rules="passwordRules" ref="passwordForm" label-width="100px">
				<el-form-item label="原密码" prop="oldPassword">
					<el-input v-model="passwordForm.oldPassword" type="password" placeholder="请输入原密码"
						show-password></el-input>
				</el-form-item>
				<el-form-item label="新密码" prop="newPassword">
					<el-input v-model="passwordForm.newPassword" type="password" placeholder="请输入新密码（至少6位）"
						show-password></el-input>
				</el-form-item>
				<el-form-item label="确认密码" prop="confirmPassword">
					<el-input v-model="passwordForm.confirmPassword" type="password" placeholder="请再次输入新密码"
						show-password></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="closePasswordDialog">取 消</el-button>
				<el-button type="primary" @click="submitPasswordChange">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		menuAPI,
		userAPI,
		systemConfigAPI
	} from '../services/api'

	export default {
		name: 'Layout',
		data() {
			return {
				searchText: '',
				dynamicMenus: [], // 动态菜单数据
				// 初始描述文本
				emptyDescription: "菜单加载中...",
				// 记录当前打开的菜单
				currentOpenedMenu: null,
				// 菜单更新时间戳，用于触发菜单重新渲染
				menuUpdateTime: Date.now(),
				websiteName: '', // 网站名称，从系统配置中获取
				// 修改密码相关
				changePasswordDialogVisible: false,
				passwordForm: {
					oldPassword: '',
					newPassword: '',
					confirmPassword: ''
				},
				passwordRules: {
					oldPassword: [{
						required: true,
						message: '请输入原密码',
						trigger: 'blur'
					}],
					newPassword: [{
							required: true,
							message: '请输入新密码',
							trigger: 'blur'
						},
						{
							min: 6,
							message: '密码长度不能少于6位',
							trigger: 'blur'
						}
					],
					confirmPassword: [{
							required: true,
							message: '请确认新密码',
							trigger: 'blur'
						},
						{
							validator: this.validateConfirmPassword,
							trigger: 'blur'
						}
					]
				},
				staticMenus: [ // 静态菜单作为备选
					{
						path: '/dashboard',
						name: '仪表盘',
						icon: 'el-icon-s-home',
						children: []
					},
					{
						path: '/system',
						name: '系统管理',
						icon: 'el-icon-setting',
						children: [{
								path: '/user-management',
								name: '用户管理',
								icon: 'el-icon-user'
							},
							{
								path: '/role-management',
								name: '角色管理',
								icon: 'el-icon-s-custom'
							},
							{
								path: '/menu-management',
								name: '菜单管理',
								icon: 'el-icon-menu'
							},
							/* { path: '/permission-management', name: '权限管理', icon: 'el-icon-lock' },*/
							{
								path: '/member-management',
								name: '会员管理',
								icon: 'el-icon-user-solid'
							}
						]
					},
					{
						path: '/knowledge-base-management',
					name: '药物百科管理',
					icon: 'el-icon-document',
					children: []
				},
				{
					path: '/science-category-management',
					name: '科普分类管理',
					icon: 'el-icon-folder',
					children: []
				},
				{
					path: '/science-article-management',
					name: '科普文章管理',
					icon: 'el-icon-document',
					children: []
				},
				{
					path: '/science-video-management',
					name: '科普视频管理',
					icon: 'el-icon-video-camera',
					children: []
				}
			],
				// 路由加载状态标志
				routesLoading: false
			}
		},
		computed: {
			userInfo() {
				return this.$store.getters.userInfo
			},
			tabs() {
				return this.$store.getters.tabs
			},
			activeTab: {
				get() {
					return this.$store.getters.activeTab
				},
				set(path) {
					this.$store.dispatch('setActiveTab', path)
				}
			},
			currentRouteTitle() {
				const route = this.$route
				return route.meta?.title || '仪表盘'
			}
		},
		created() {
			// 动态路由加载由路由守卫统一处理
		},
		watch: {
			$route(to) {
				this.addTab(to)
			},
			// 监听用户信息变化，登录后重新加载菜单
			userInfo: {
				handler(newVal) {
					if (newVal && newVal.id) {
						this.loadUserMenus()
					}
				},
				deep: true
			}
		},
		mounted() {
			this.addTab(this.$route)

			// 使用setTimeout延迟加载，避免阻塞页面渲染
			setTimeout(() => {
				// 加载用户权限菜单
				this.loadUserMenus()

				// 加载动态路由 - 在组件挂载时主动加载一次，确保路由配置完整
				this.loadDynamicRoutes()

				// 检查默认页面显示
				this.checkDefaultPage()

				// 加载网站名称配置
				this.loadWebsiteConfig()
			}, 100)
		},
		methods: {
			// 加载网站名称配置
			async loadWebsiteConfig() {
				try {
					// 尝试获取WebsiteName配置
					const websiteNameConfig = await systemConfigAPI.getConfigByKey('WebsiteName')
					if (websiteNameConfig && websiteNameConfig.value) {
						this.websiteName = websiteNameConfig.value
						// 更新页面标题
						document.title = this.websiteName
					}
				} catch (error) {
					console.error('加载网站名称配置失败:', error)
					// 如果获取WebsiteName失败，尝试获取SystemName
					try {
						const systemNameConfig = await systemConfigAPI.getConfigByKey('SystemName')
						if (systemNameConfig && systemNameConfig.value) {
							this.websiteName = systemNameConfig.value
							// 更新页面标题
							document.title = this.websiteName
						}
					} catch (innerError) {
						console.error('加载系统名称配置失败:', innerError)
					}
				}
			},
			// 加载动态路由
			async loadDynamicRoutes() {
				// 避免重复加载
				if (this.routesLoading) {
					console.log('路由正在加载中，跳过重复加载')
					return
				}

				this.routesLoading = true
				try {
					// 从路由模块导入动态路由添加方法
					const {
						addDynamicRoutes
					} = await import('@/router/index.js')
					await addDynamicRoutes()
					console.log('动态路由加载完成')
				} catch (error) {
					console.error('加载动态路由失败:', error)
					this.$message.error('路由加载失败，请刷新页面重试')
				} finally {
					this.routesLoading = false
				}
			},

			// 处理和验证菜单数据，确保唯一性和结构正确性
			processMenuData(menus) {
				if (!menus || !Array.isArray(menus)) {
					return [];
				}

				// 使用缓存避免重复处理
				const processedMenus = [];
				const pathSet = new Set();

				for (const menu of menus) {
					if (!menu || !menu.path) continue;

					// 避免重复路径
					if (pathSet.has(menu.path)) continue;
					pathSet.add(menu.path);

					// 创建新的菜单对象，避免修改原始数据
					const processedMenu = {
						...menu
					};

					// 确保菜单有id
					if (!processedMenu.id) {
						processedMenu.id = `menu-${processedMenu.path.replace(/\//g, '-')}`;
					}

					// 处理子菜单
					if (processedMenu.children && Array.isArray(processedMenu.children)) {
						const processedChildren = [];
						const childPathSet = new Set();

						for (const child of processedMenu.children) {
							if (!child || !child.path) continue;

							// 避免重复子菜单路径
							if (childPathSet.has(child.path)) continue;
							childPathSet.add(child.path);

							const processedChild = {
								...child
							};
							if (!processedChild.id) {
								processedChild.id = `menu-${processedChild.path.replace(/\//g, '-')}`;
							}
							processedChildren.push(processedChild);
						}

						processedMenu.children = processedChildren;
					}

					processedMenus.push(processedMenu);
				}

				return processedMenus;
			},

			// 获取用户权限菜单
			async loadUserMenus() {
				try {
					const response = await menuAPI.getUserMenus()
					console.log('获取菜单情况：', response)
					if (response && response.length > 0) {
						// 处理菜单数据，确保结构正确
						this.dynamicMenus = this.processMenuData(response);
						// 更新时间戳触发重新渲染
						this.menuUpdateTime = Date.now();
						// 重置当前打开的菜单
						this.currentOpenedMenu = null;
					} else {
						console.warn('未获取到权限菜单')
						this.emptyDescription = '您当前权限未加载到任何菜单'
						this.$message.error('您当前权限未加载到任何菜单')
					}
				} catch (error) {
					console.error('获取用户权限菜单失败:', error)
					this.$message.error('加载菜单失败，请刷新页面重试')
				}
			},
			addTab(route) {
				if (route.meta && route.meta.title) {
					this.$store.dispatch('addTab', {
						path: route.path,
						title: route.meta.title
					})
				}
			},
			// 处理菜单打开事件，确保只有一个一级目录可以打开
			handleMenuOpen(menuKeys) {
				// menuKeys数组的第一个元素通常是一级菜单的index
				if (menuKeys && menuKeys.length > 0) {
					// 只记录一级菜单的key
					this.currentOpenedMenu = menuKeys[0];
				}
			},

			// 处理菜单选择事件，确保点击菜单时正常响应
			handleMenuSelect(key, keyPath) {
				// 处理一级菜单点击
				if (keyPath && keyPath.length === 1) {
					// 对于一级菜单，确保其被设置为当前打开的菜单
					this.currentOpenedMenu = key;
				}
				// 处理二级菜单点击
				else if (keyPath && keyPath.length > 1) {
					// 确保一级菜单保持打开状态
					this.currentOpenedMenu = keyPath[0];
				}
			},

			removeTab(path) {
				if (path != '/dashboard') {
					// 如果关闭的是当前激活的tab，需要先跳转到其他页面
					if (this.activeTab === path) {
						const tabs = this.tabs
						let targetPath = '/dashboard'

						// 找到要跳转的目标路径（通常是前一个tab）
						if (tabs.length > 1) {
							const currentIndex = tabs.findIndex(tab => tab.path === path)
							if (currentIndex > 0) {
								targetPath = tabs[currentIndex - 1].path
							} else if (tabs.length > 1) {
								targetPath = tabs[1].path
							}
						}

						// 先跳转到目标页面，然后再移除tab
						this.$router.push(targetPath).then(() => {
							// 确保路由跳转完成后再移除tab
							this.$store.dispatch('removeTab', path)
						})
					} else {
						// 如果不是当前激活的tab，直接移除
						this.$store.dispatch('removeTab', path)
					}
				}
			},
			clickTab(tab) {
				// 只有当点击的不是当前激活的tab时才进行路由跳转
				if (tab.name !== this.$route.path) {
					this.$router.push(tab.name)
				}
			},
			handleLogout() {
				this.$confirm('确定要退出登录吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$store.dispatch('logout')
					this.$router.push('/login')
					this.$message.success('退出成功')
				}).catch(() => {
					// 用户点击取消，不做任何操作
					console.log('用户取消退出登录')
				})
			},

			// 检查默认页面显示
			checkDefaultPage() {
				// 如果当前路由是根路径，根据权限决定默认页面
				if (this.$route.path === '/') {
					// 检查用户是否有仪表盘权限
					const hasDashboardPermission = this.checkDashboardPermission()

					if (hasDashboardPermission) {
						// 有权限则跳转到仪表盘
						this.$router.push('/dashboard')
					} else {
						// 没有权限则保持在当前页面（空白页面）
						// 可以在这里添加一些空白页面的渲染效果
						console.log('用户没有仪表盘权限，显示空白页面')
					}
				}
			},

			// 检查用户是否有仪表盘权限
			checkDashboardPermission() {
				// 这里可以根据实际业务逻辑检查用户权限
				// 暂时简单判断：如果用户有菜单权限，则认为有仪表盘权限
				return this.dynamicMenus.length > 0 ||
					(this.staticMenus && this.staticMenus.length > 0)
			},

			// 打开修改密码对话框
			handleChangePassword() {
				this.changePasswordDialogVisible = true
				// 重置表单
				this.$nextTick(() => {
					this.$refs.passwordForm.resetFields()
				})
			},

			// 验证确认密码
			validateConfirmPassword(rule, value, callback) {
				if (value === '') {
					callback(new Error('请再次输入密码'))
				} else if (value !== this.passwordForm.newPassword) {
					callback(new Error('两次输入密码不一致!'))
				} else {
					callback()
				}
			},

			// 提交修改密码
			async submitPasswordChange() {
				let userid = this.userInfo.id || 0
				if (userid == 0) {
					this.$message.error('当前账号信息异常')
				} else {
					this.$refs.passwordForm.validate(async (valid) => {
						if (valid) {
							try {
								const response = await userAPI.changePassword(userid, {
									oldPassword: this.passwordForm.oldPassword,
									newPassword: this.passwordForm.newPassword
								})
								console.log(response)
								if (response && (response.Success || response.success)) {
									this.$message.success('密码修改成功')
									this.changePasswordDialogVisible = false
									// 清空表单
									this.passwordForm = {
										oldPassword: '',
										newPassword: '',
										confirmPassword: ''
									}
								} else {
									this.$message.error(response.Message || response.message || '密码修改失败')
								}
							} catch (error) {
								console.error('修改密码失败:', error)
								// 检查是否是401错误，如果是则说明token过期，需要重新登录
								if (error.response && error.response.status === 401) {
									this.$message.error('登录已过期，请重新登录')
									this.$store.dispatch('logout')
									this.$router.push('/login')
								} else {
									this.$message.error(error.response?.data?.message || '密码修改失败，请重试')
								}
							}
						} else {
							return false
						}
					})
				}
			},

			// 关闭修改密码对话框
			closePasswordDialog() {
				this.changePasswordDialogVisible = false
				// 清空表单
				this.passwordForm = {
					oldPassword: '',
					newPassword: '',
					confirmPassword: ''
				}
			}
		}
	}
</script>

<style scoped>
	.layout-container {
		display: flex;
		height: 100vh;
		background: #f5f7fa;
	}

	.sidebar {
		width: 220px;
		background: #fff;
		overflow-y: auto;
	}

	.logo {
		height: 60px;
		display: flex;
		align-items: center;
		justify-content: center;
		color: white;
		background: #1B63CF;
		/*border-bottom: 1px solid #1f2d3d;*/
	}

	.logo h2 {
		font-size: 18px;
		margin: 0;
	}

	.el-menu-vertical {
		border-right: none;
	}

	.main-container {
		flex: 1;
		display: flex;
		flex-direction: column;
		overflow: hidden;
	}

	.header {
		height: 60px;
		background: white;
		border-bottom: 1px solid #e6e6e6;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 20px;
		box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
	}

	.header-left h3 {
		margin: 0;
		color: #333;
		font-size: 18px;
	}

	.header-right {
		display: flex;
		align-items: center;
		gap: 10px;
	}

	.user-info {
		display: flex;
		align-items: center;
		cursor: pointer;
		padding: 0 10px;
	}

	.tabs-container {
		background: white;
		padding: 0 20px;
		border-bottom: 1px solid #e6e6e6;
	}

	.content {
		flex: 1;
		padding: 20px;
		overflow-y: auto;
		background: white;
		margin: 20px;
		border-radius: 4px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	}
</style>